import styles from './style.module.scss';
import Modal from '../../common/modal/Modal';
import Button from '../../ui/Button';
import { LoadingIcon } from '../../../assets/Icon';

type MintConfirmationModalProps = {
  open: boolean;
  information: {
    tokenNameOrSymbol: string;
    tokensToMint: number;
  };
  onConfirm: () => void;
  onReject: () => void;
  isLoading: boolean;
};

const MintConfirmationModal = ({
  open,
  information,
  onConfirm,
  onReject,
  isLoading,
}: MintConfirmationModalProps) => {
  const currentDate = new Date().toLocaleDateString();

  return (
    <Modal
      open={open}
      title="Mint Confirmation"
      onClose={onReject}
      isCloseIconVisible={!isLoading}
      dialogClassName={styles.dialog_content}
    >
      <div className={styles.mintWrapper}>
        <div className={styles.mintItem}>
          <label>Token Name or Symbol:</label>
          <span>{information.tokenNameOrSymbol}</span>
        </div>
        <div className={styles.mintItem}>
          <label>Tokens to Mint:</label>
          <span>{information.tokensToMint}</span>
        </div>
        <div className={styles.mintItem}>
          <label>Minting Date</label>
          <span>{currentDate}</span>
        </div>
      </div>
      <div className={styles.actions}>
        <Button variant="outline" onClick={onReject} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="dark"
          onClick={onConfirm}
          className={styles.delete_btn}
          disabled={isLoading}
        >
          {isLoading ? <LoadingIcon size={18} /> : 'Confirm'}
        </Button>
      </div>
    </Modal>
  );
};

export default MintConfirmationModal;
